module.exports = __webpack_public_path__ + "media/images/medicine-40843768c1449c15aa91d172e8fb6e30.svg";